import axiosInstance from '@/axiosInstance'
import axiosInstanceV3 from '@/axiosInstanceV3'

export async function fetchImportWeek(payload) {
  const response = await axiosInstance.post(
    '/import_plan/import_week_get.php',
    payload
  )

  return response.data
}

export async function saveImportRows(payload) {
  const response = await axiosInstance.post(
    '/import_plan/import_rows_save.php',
    payload
  )

  return response.data
}

export async function saveDispatcherNeeds(payload) {
  const response = await axiosInstance.post(
    '/import_plan/import_dispatcher_need_save.php',
    payload
  )

  return response.data
}


export async function searchRendszam(payload) {
  const response = await axiosInstance.post(
    '/rendszam/list_rendszam.php',
    payload
  )

  return response.data
}

export async function fetchImportCfg(payload) {
  const response = await axiosInstance.post(
    '/import_plan/import_cfg_list.php',
    payload
  )

  return response.data
}

export async function saveImportCfg(payload) {
  const response = await axiosInstance.post(
    '/import_plan/import_cfg_save.php',
    payload
  )

  return response.data
}


export async function searchMegrendelo(payload) {
  const response = await axiosInstance.post(
    '/megrendelo/list_megrendelo.php',
    payload,
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  )

  return response.data
}

export async function searchCikk(payload) {
  const response = await axiosInstanceV3.get('/cikk.php', {
    params: {
      cikk_cegaz: payload.ceg_az,
      cikk_megn: payload.search
    }
  })

  return response.data
}

export async function searchTav(payload) {
  const response = await axiosInstance.post(
    '/tav/list_tav.php',
    {
      search: payload.search,
      ceg_az: payload.ceg_az
    },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  )

  return response.data
}

export async function searchHely(payload) {
  const response = await axiosInstance.post(
    '/hely/list_hely.php',
    {
      hely_tavaz: payload.hely_tavaz
    },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  )

  return response.data
}

export async function fetchMissingImportSections(payload) {
  const response = await axiosInstance.post(
    '/import_plan/import_week_missing_sections.php',
    payload
  )

  return response.data
}

export async function addImportSectionToWeek(payload) {
  const response = await axiosInstance.post(
    '/import_plan/import_week_add_section.php',
    payload
  )

  return response.data
}

export async function deleteImportSectionFromWeek(payload) {
  const response = await axiosInstance.post(
    '/import_plan/import_week_delete_section.php',
    payload
  )

  return response.data
}

export async function updateImportSectionStatus(payload) {
  const response = await axiosInstance.post(
    '/import_plan/import_week_section_status.php',
    payload
  )

  return response.data
}

export async function saveImportSectionReferences(payload) {
  const response = await axiosInstance.post(
    'import_plan/import_section_references_save.php',
    payload
  )

  return response.data
}

export async function fetchImportFuvarszervezok(payload) {
  const response = await axiosInstance.post(
    'import_plan/import_fuvarszervezo_list.php',
    payload
  )

  return response.data
}


/****** clearing */


export async function fetchImportClearing(payload) {
  const response = await axiosInstance.post(
    'import_plan/import_clearing_get.php',
    payload
  )

  return response.data
}

export async function saveImportClearing(payload) {
  const response = await axiosInstance.post(
    'import_plan/import_clearing_save.php',
    payload
  )

  return response.data
}

export async function sendImportClearing(payload) {
  const response = await axiosInstance.post(
    'import_plan/import_clearing_send.php',
    payload
  )

  return response.data
}

export async function fetchImportMegrendelok(payload) {
  const response = await axiosInstance.post(
    'import_plan/import_megrendelo_list.php',
    payload
  )

  return response.data
}

export async function fetchImportFelrakok(payload) {
  const response = await axiosInstance.post(
    'import_plan/import_felrako_list.php',
    payload
  )

  return response.data
}

export async function fetchImportLerakok(payload) {
  const response = await axiosInstance.post(
    'import_plan/import_lerako_list.php',
    payload
  )

  return response.data
}

export async function fetchImportCikkek(payload) {
  const response = await axiosInstance.post(
    'import_plan/import_cikk_list.php',
    payload
  )

  return response.data
}

export async function fetchImportFelhelyek(payload) {
  const response = await axiosInstance.post(
    'import_plan/import_felhely_list.php',
    payload
  )

  return response.data
}

export async function fetchImportLerhelyek(payload) {
  const response = await axiosInstance.post(
    'import_plan/import_lerhely_list.php',
    payload
  )

  return response.data
}

